class ReziFootbar {
  constructor() {
    const root = document.querySelector('.rezi-footbar');

    if (root) {
      const wrapper = root.querySelector('.rezi-footbar__wrapper');
      const items = root.querySelectorAll('.rezi-footbar__item');

      const changeAnimation = () => {
        let width = 0;
        let duration = 0;

        items.forEach(item => {
          if (width < window.innerWidth) {
            width = width + item.getBoundingClientRect().width;
            duration = duration + 4;
          }
        });

        wrapper.style.setProperty('--width', -width + 'px');
        wrapper.style.setProperty('--duration', duration + 's');
      }

      document.addEventListener('DOMContentLoaded', () => changeAnimation());
      window.addEventListener('resize', () => changeAnimation());
    }
  }
}

export default ReziFootbar;
